import Vue from "vue";
import GlobalEvents from "vue-global-events";
import { default as Vuedals } from "vuedals";
import VueProgressBar from "vue-progressbar";
import VueLocalStorage from "vue-ls";
import Gravatar from "vue-gravatar";

Vue.component("v-gravatar", Gravatar);

Vue.use(VueProgressBar, {
	color: "#4c85ff",
	failedColor: "red"
});

Vue.use(Vuedals);
Vue.component("GlobalEvents", GlobalEvents);
require("vue2-animate/dist/vue2-animate.min.css");

Vue.use(VueLocalStorage, {
	name: "localStore",
	bind: true
});

let intercomKey = process.env.VUE_APP_INTERCOM_APP_ID;

(function() {
	var w = window;
	var ic = w.Intercom;
	if (typeof ic === "function") {
		ic("reattach_activator");
		ic("update", w.intercomSettings);
	} else {
		var d = document;
		var i = function() {
			i.c(arguments);
		};
		i.q = [];
		i.c = function(args) {
			i.q.push(args);
		};
		w.Intercom = i;
		var l = function() {
			var s = d.createElement("script");
			s.type = "text/javascript";
			s.async = true;
			s.src = `https://widget.intercom.io/widget/${intercomKey}`;
			var x = d.getElementsByTagName("script")[0];
			x.parentNode.insertBefore(s, x);
		};
		if (w.attachEvent) {
			w.attachEvent("onload", l);
		} else {
			w.addEventListener("load", l, false);
		}
	}
})();
window.Intercom("boot", {
	app_id: intercomKey,
	hide_default_launcher: true
});
